/**
 * Lucide line icons for Payroll + Employee Actions (match Attendance redesign).
 * Soft-3D maps remain in payrollActionChrome for legacy surfaces only.
 */
import {
  ArrowLeftRight,
  BadgeCheck,
  FileText,
  HandCoins,
  Landmark,
  Layers,
  LogOut,
  Receipt,
  RefreshCw,
  Scale,
  UserRound,
  Wallet,
} from "lucide-react";

const stroke = 1.7;

function wrap(Icon) {
  return function ModuleLucideIcon({ size = 20, className = "", ...rest }) {
    return (
      <Icon
        size={size}
        strokeWidth={stroke}
        className={className}
        aria-hidden
        {...rest}
      />
    );
  };
}

export const PAYROLL_ACTION_LUCIDE_ICONS = {
  assigned_structure: wrap(Layers),
  salary_revision: wrap(RefreshCw),
  update_statutory: wrap(Landmark),
  tax_planning: wrap(Scale),
  loan: wrap(HandCoins),
  leave_encashment: wrap(Wallet),
  advance: wrap(Wallet),
  reimbursement: wrap(Receipt),
  process_fnf: wrap(BadgeCheck),
};

export const EMPLOYEE_ACTION_LUCIDE_ICONS = {
  view_employee: wrap(UserRound),
  generate_letter: wrap(FileText),
  confirmation: wrap(BadgeCheck),
  transfer: wrap(ArrowLeftRight),
  resignation: wrap(LogOut),
};
